import React from 'react';

export default function ProjectSection(){
  return (
    <div className='content-section alternate-section-background'  id='section-projects'>
      <div className='content-header'>projects</div>
      <div className='content-body'>
        <p>
          <a href='https://stratosyr.itch.io/pixel-art-card-deck' target='_blank' rel="noreferrer">Pixel Art Playing Cards</a> is a tilset of assets for use in programming basic card games. Made with Aseprite.
        </p>
        <p>
          <a href='https://stratosyr.itch.io/pixel-art-card-deck' target='_blank' rel="noreferrer">The Hungry Seagull</a> is my first PICO-8 game. Play three levels to score high enough to be crowned the fry queen.
        </p>
        <p>
          <b>Twilio Demo Platform</b> is a <a href='https://github.com/kristajg/kg-demo-app' target='_blank' rel="noreferrer">React frontend</a> &#38; <a href='https://github.com/kristajg/kg-demo-api' target='_blank' rel="noreferrer">Node + Express</a> project showcasing core communications products: SMS, voice, 2FA.
        </p>
        <p>
          <a href='https://github.com/kristajg/pburgh-phaser' target='_blank' rel="noreferrer">Pigeonburgh</a>, a <b>top-down RPG game</b> in progress built with Phaser.io. Includes friendship, dystopian future, [pigeons].
        </p>
        <p>
          <a href='https://github.com/kristajg/cozy-holiday' target='_blank' rel="noreferrer">Cozy Holiday</a> is a react <b>npm package</b>. Features holiday themed pixel art for websites.
        </p>
        <p>
          <a href='https://github.com/kristajg/react-aws-audio-transcription' target='_blank' rel="noreferrer">Real time audio transcription</a> using AWS Transcribe, React.
        </p>
        <p>
          Various pixel art currently parked in <a href='https://www.artstation.com/stratosyr' target='_blank' rel="noreferrer">Artstation</a>.
        </p>
        <p>
          Some old experimental <a href='https://soundcloud.com/stratosyr/tracks' target='_blank' rel="noreferrer">chiptune music tracks</a> made with Little Sound Dj and a gameboy emulator.
        </p>
      </div>
    </div> 
  )
}
